import type { ColourGroup } from '../../gql';

import { randNumber, randColor } from '@ngneat/falso';

import { mockMasterColour } from '../mockMasterColour';

export const mockColourGroup = (
    overwrite?: Partial<ColourGroup>
): ColourGroup => {
    const masterColourAmount = randNumber({ min: 1, max: 10 });
    return {
        colourGroupName: randColor(),
        colourGroupNumber: randNumber(),
        masterColours: Array.from({ length: masterColourAmount }, () =>
            mockMasterColour()
        ),
        isDeleted: false,
        ...overwrite,
        ['__typename']: 'ColourGroup',
    };
};
